import requests from "api/requests";
import { IStatus } from "pages/settings/statuses/base/types";
import React, { useEffect } from "react";

export default function useStatuses(){
  const [ statusTypes, setStatusTypes] = React.useState<IStatus[]|undefined>(undefined);

  useEffect(() => {
    requests.get('/settings/statuses/driver-request/').then((r) => {
      setStatusTypes(r.body);
    })
  }, [])

  return statusTypes;
}